import React, { Component } from "react";
import { connect } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { showSearch, addToCart, removeFromCart, updateCartItem } from "../store/actions/productActions";
import { useTheme } from "../context/ThemeContext";
import { getTheme } from "../config/themes";
import { SITE_URL } from "../config/domain";
import { logError } from "../ErrorLogger";
import { logAction, A } from "./AdminLogger";


class CartQtyInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = { editing: false, val: '', orig: 0 };
  }

  startEdit = () => {
    const qty = this.props.item.quantity;
    this.setState({ editing: true, val: String(qty), orig: qty }, () => {
      if (this.input) { this.input.focus(); this.input.select(); }
    });
  };

  commit = () => {
    if (!this.state.editing) return;
    const _maxQ = window._bvS?.maxCartQty || 99;
    const newQty = Math.min(_maxQ, Math.max(1, parseInt(this.state.val, 10) || 1));
    const diff = newQty - this.state.orig;
    if (diff > 0) { for (let i = 0; i < diff; i++) this.props.incItem(this.props.item); }
    else if (diff < 0) { for (let i = 0; i < Math.abs(diff); i++) this.props.decItem(this.props.item); }
    this.setState({ editing: false });
  };

  cancel = () => this.setState({ editing: false });

  render() {
    const { item } = this.props;
    const { editing, val } = this.state;
    if (editing) {
      return (
        <input
          ref={el => this.input = el}
          type="number" min="1" max={window._bvS?.maxCartQty || 99}
          value={val}
          onChange={e => this.setState({ val: e.target.value })}
          onBlur={this.commit}
          onKeyDown={e => { if (e.key === 'Enter') e.target.blur(); if (e.key === 'Escape') this.cancel(); }}
          onClick={e => e.stopPropagation()}
        />
      );
    }
    return (
      <span onClick={e => { e.stopPropagation(); this.startEdit(); }} style={{ cursor: 'text' }}>
        {item.quantity}
      </span>
    );
  }
}

class Cart extends Component {
  constructor(props) {
    super(props);
    this.props.showSearch(false);
    this.trashRef = React.createRef();
    // Restore organic state from localStorage
    let savedOrganic = {};
    try { savedOrganic = JSON.parse(localStorage.getItem('bv_cart_organic') || '{}'); } catch(e) {}
    this.state = {
      confirmStep: false,
      sending: false,
      organicToggles: savedOrganic.organicToggles || {},
      organicQtys:    savedOrganic.organicQtys    || {},
      nonOrgQtys:     savedOrganic.nonOrgQtys     || {},
      organicModal: null,
      previewItem: null,
      previewY: null,
      previewFading: false,
    };
  }

  componentWillUnmount() {
    this._unmounted = true;
    if (this.scrollListener) window.removeEventListener('scroll', this.scrollListener, true);
    if (this.previewTimeout) clearTimeout(this.previewTimeout);
    if (this._flyTimer) clearTimeout(this._flyTimer);
    if (this._previewFadeTimer) clearTimeout(this._previewFadeTimer);
  }

  handleDelete = (item, e) => {
    const trashEl = this.trashRef.current;
    const btn     = e.currentTarget;
    const from    = btn.getBoundingClientRect();

    // Створюємо DOM елемент як в Product.js
    const fly = document.createElement('div');
    fly.style.cssText = `
      position: fixed;
      left: ${from.left + from.width / 2 - 16}px;
      top:  ${from.top  + from.height / 2 - 16}px;
      width: 32px; height: 32px;
      background: linear-gradient(135deg, #d4500a, #e8390a);
      border-radius: 50%;
      display: flex; align-items: center; justify-content: center;
      pointer-events: none;
      z-index: 9999;
      transition: all 0.45s cubic-bezier(0.4, 0, 0.2, 1);
      box-shadow: 0 4px 12px rgba(232,57,10,0.4);
    `;
    fly.innerHTML = `<svg viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" width="18" height="18">
      <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/>
      <line x1="3" y1="6" x2="21" y2="6"/>
      <path d="M16 10a4 4 0 01-8 0"/>
    </svg>`;
    document.body.appendChild(fly);

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (trashEl) {
          const to = trashEl.getBoundingClientRect();
          fly.style.left    = (to.left + to.width  / 2 - 8) + 'px';
          fly.style.top     = (to.top  + to.height / 2 - 8) + 'px';
          fly.style.width   = '16px';
          fly.style.height  = '16px';
          fly.style.opacity = '0';
        }
      });
    });

    this._flyTimer = setTimeout(() => {
      if (document.body.contains(fly)) document.body.removeChild(fly);
      if (this._unmounted) return;
      this.props.deleteItem(item);
      // Якщо видаляємо органік — очищаємо state
      const baseId = String(item.id).endsWith('_org') ? item.id.replace('_org', '') : item.id;
      if (String(item.id).endsWith('_org')) {
        // Скидаємо organicSelected на base item теж
        if (this.props.cartList[baseId]) {
          this.props.updateCartItem(baseId, { organicSelected: false });
        }
        this.setState(prev => {
          const organicToggles = { ...prev.organicToggles, [baseId]: false };
          const organicQtys    = { ...prev.organicQtys,    [baseId]: 0 };
          const nonOrgQtys     = { ...prev.nonOrgQtys };
          try { localStorage.setItem('bv_cart_organic', JSON.stringify({ organicToggles, organicQtys, nonOrgQtys })); } catch(e2) {}
          return { organicToggles, organicQtys, nonOrgQtys };
        });
      } else {
        // Видаляємо звичайний — очищаємо organic state теж якщо є
        this.setState(prev => {
          const organicToggles = { ...prev.organicToggles };
          const organicQtys    = { ...prev.organicQtys };
          const nonOrgQtys     = { ...prev.nonOrgQtys };
          delete organicToggles[baseId];
          delete organicQtys[baseId];
          delete nonOrgQtys[baseId];
          try { localStorage.setItem('bv_cart_organic', JSON.stringify({ organicToggles, organicQtys, nonOrgQtys })); } catch(e2) {}
          return { organicToggles, organicQtys, nonOrgQtys };
        });
      }
    }, 480);
  };

  handleSendOrderClick = () => this.setState({ confirmStep: true });
  handleCancelOrder   = () => this.setState({ confirmStep: false });

  handleConfirmOrder = async () => {
    const email    = (() => { try { return localStorage.getItem("userEmail"); } catch { return ""; } })();
    const password = (() => { try { return sessionStorage.getItem("userPassword") || localStorage.getItem("userPwd") || ""; } catch { return ""; } })();
    if (!email) { this.props.navigate("/login"); return; }
    // Якщо пароль відсутній — попросити ввести
    if (!password) {
      const entered = window.prompt("Session expired. Please enter your password:");
      if (!entered) return;
      try { sessionStorage.setItem("userPassword", entered); } catch(e) {}
      try { localStorage.setItem("userPwd", entered); } catch(e) {}
    }
    const finalPassword = (() => { try { return sessionStorage.getItem("userPassword") || localStorage.getItem("userPwd") || ""; } catch { return ""; } })();
    this.setState({ sending: true });
    const cartListSnap = this.props.cartList;
    const { organicToggles } = this.state;
    const cartItems = Object.values(cartListSnap).map(item => {
      const isOrgById = String(item.id).endsWith('_org');
      const realId    = isOrgById ? item.id.replace('_org','') : item.id;
      // Organic: _org id OR toggle is on in state (not organicSelected which is stripped on reload)
      const isOrg     = isOrgById || !!(organicToggles[realId]);
      const fresh     = (this.props.allProducts || []).find(p => p.id === realId);
      return fresh
        ? { ...item, id: realId, weight: fresh.weight, organic: isOrg, quantity_type: fresh.quantity_type, image: fresh.image }
        : { ...item, id: realId, organic: isOrg };
    });
    try {
      const res = await fetch(`${SITE_URL}/api/order`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password: finalPassword, cart: cartItems }),
      });
      const data = await res.json();
      if (data.success) {
        this.props.clearCart();
        try { localStorage.removeItem('bv_cart_organic'); } catch(e) {}
        // Сповіщаємо адмінку про новий ордер
        try { localStorage.setItem('bv_new_order', JSON.stringify({ invoiceId: data.invoiceId, ts: Date.now() })); } catch(e) {}
        logAction(A.CREATE, 'order', data.invoiceId, `New store order ${data.invoiceNumber} by ${email}`);
        this.props.navigate("/profile?invoiceId=" + data.invoiceId);
      } else {
        alert(data.error || "Order failed");
        this.setState({ sending: false, confirmStep: false });
      }
    } catch (err) {
      console.error(err);
      logError(err, "Cart.sendOrder");
      alert("Server error");
      this.setState({ sending: false, confirmStep: false });
    }
  };

  toggleOrganic = (id, qty) => {
    // baseId/orgId computed below
    // id може бути базовий або _org
    const baseId = String(id).endsWith('_org') ? id.replace('_org','') : id;
    const orgId  = baseId + '_org';
    const isOn   = this.state.organicToggles[baseId] || false;
    const cartBase = this.props.cartList[baseId];
    const cartOrg  = this.props.cartList[orgId];

    if (isOn) {
      // ВИМИКАЄМО
      if (qty === 1 && cartBase) {
        // qty=1 — оновлюємо organic флаг без переміщення
        this.props.updateCartItem(baseId, { organicSelected: false });
      } else if (cartOrg) {
        // qty>1 — видаляємо _org рядок
        this.props.deleteItem({ ...cartOrg, id: orgId });
      }
      this.setState(prev => {
        const organicToggles = { ...prev.organicToggles, [baseId]: false };
        const organicQtys    = { ...prev.organicQtys,    [baseId]: 0 };
        try { localStorage.setItem('bv_cart_organic', JSON.stringify({ organicToggles, organicQtys })); } catch(e) {}
        return { organicToggles, organicQtys };
      });
    } else {
      // ВМИКАЄМО
      if (qty === 1 && cartBase) {
        // qty=1 — оновлюємо organic флаг без переміщення
        this.props.updateCartItem(baseId, { organicSelected: true });
        this.setState(prev => {
          const organicToggles = { ...prev.organicToggles, [baseId]: true };
          const organicQtys    = { ...prev.organicQtys,    [baseId]: 1 };
          try { localStorage.setItem('bv_cart_organic', JSON.stringify({ organicToggles, organicQtys })); } catch(e) {}
          return { organicToggles, organicQtys };
        });
      } else {
        // qty>1 — відкриваємо modal
        this.setState({ organicModal: { id: baseId, qty } });
      }
    }
  };

  setOrganicQty = (id, qty, organicQty) => {
    const prevOrgQty = this.state.organicQtys[id] || 0;
    const orgId = id + '_org';
    const baseItem = this.props.cartList[id] || this.props.cartList[orgId];

    if (organicQty === 0) {
      // Видаляємо органік запис з cart повністю
      if (this.props.cartList[orgId]) {
        this.props.deleteItem({ ...baseItem, id: orgId });
      }
      // Скидаємо organicSelected на base item
      if (this.props.cartList[id]) {
        this.props.updateCartItem(id, { organicSelected: false });
      }
    } else {
      // Додаємо/оновлюємо незалежний organic запис
      const diff = organicQty - prevOrgQty;
      if (diff > 0) {
        for (let i = 0; i < diff; i++) {
          this.props.incItem({ ...baseItem, id: orgId, organic: true });
        }
      } else if (diff < 0) {
        for (let i = 0; i < Math.abs(diff); i++) {
          this.props.decItem({ ...baseItem, id: orgId, organic: true });
        }
      }
    }

    this.setState(prev => {
      const next = {
        organicModal: null,
        organicToggles: Object.assign({}, prev.organicToggles, { [id]: organicQty > 0 }),
        organicQtys:    Object.assign({}, prev.organicQtys,    { [id]: organicQty }),
      };
      try { localStorage.setItem('bv_cart_organic', JSON.stringify({
        organicToggles: next.organicToggles,
        organicQtys:    next.organicQtys,
      })); } catch(e) {}
      return next;
    });
  };

  tapPreview   = (item, e) => {
    if (this.previewTimeout) clearTimeout(this.previewTimeout);
    if (this.scrollListener) window.removeEventListener('scroll', this.scrollListener, true);

    const row  = e.currentTarget;
    const rect = row.getBoundingClientRect();
    this.setState({ previewItem: item, previewY: rect.top - 10, previewFading: false });

    // Ховаємо при скролі
    this.scrollListener = () => {
      this.setState({ previewFading: true });
      this._previewFadeTimer = setTimeout(() => {
        if (!this._unmounted) this.setState({ previewItem: null, previewFading: false });
      }, 300);
      window.removeEventListener('scroll', this.scrollListener, true);
    };
    window.addEventListener('scroll', this.scrollListener, { passive: true, capture: true });
  };

  render() {
    const cartList = this.props.cartList;
    const allProducts = this.props.allProducts || [];
    const { confirmStep, sending, organicToggles, organicQtys, organicModal, previewItem, previewY, previewFading } = this.state;

    const cartItems = Object.values(cartList).filter(item => !String(item.id).endsWith('_org')).flatMap(function(item) {
      const fresh = allProducts.find(function(p) { return p.id === item.id; });
      const merged = fresh
        ? Object.assign({}, item, { weight: fresh.weight, organic: fresh.organic, quantity_type: fresh.quantity_type, image: fresh.image })
        : item;
      return [merged];
    });

    const displayItems = cartItems.flatMap(item => {
      if (String(item.id).endsWith('_org')) return [];
      const orgId    = item.id + '_org';
      const orgEntry = cartList[orgId];
      const rows = [{ ...item, _displayOrganic: false, _splitKey: item.id }];
      if (orgEntry && orgEntry.quantity > 0) {
        rows.push({ ...item, id: orgId, quantity: orgEntry.quantity, _displayOrganic: true, _splitKey: orgId, _orgOnly: true });
      }
      return rows;
    });

    // Також показуємо _org записи що не мають батька (якщо простий видалено)
    const orphanOrgItems = Object.values(cartList).filter(item => {
      if (!String(item.id).endsWith('_org')) return false;
      const baseId = item.id.replace('_org', '');
      return !cartList[baseId]; // немає батька
    }).map(item => {
      const baseId = item.id.replace('_org', '');
      const fresh = allProducts.find(p => p.id === baseId);
      return fresh
        ? { ...item, ...{ weight: fresh.weight, quantity_type: fresh.quantity_type, image: fresh.image }, _displayOrganic: true, _splitKey: item.id, _orgOnly: true }
        : { ...item, _displayOrganic: true, _splitKey: item.id, _orgOnly: true };
    });

    const allDisplayItems = [...displayItems, ...orphanOrgItems];

    if (allDisplayItems.length === 0) {
      return (
        <div className="cart-empty">
          <div className="cart-empty-scene">
            <div className="cart-empty-orb cart-empty-orb--1" />
            <div className="cart-empty-orb cart-empty-orb--2" />
            <div className="cart-empty-cart-wrap">
              {/* bouncing dots */}
              <div className="cart-empty-dots">
                <span /><span /><span />
              </div>
              <svg className="cart-empty-svg" viewBox="0 0 120 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                {/* handle */}
                <path d="M10 18 L28 18 L42 68 L95 68 L108 32 L38 32" stroke={this.props.cartColors.stroke} strokeWidth="5" strokeLinecap="round" strokeLinejoin="round"/>
                {/* basket body */}
                <path className="cart-basket" d="M38 32 L42 68 L95 68 L108 32 Z" fill={this.props.cartColors.fill} stroke={this.props.cartColors.stroke} strokeWidth="4.5" strokeLinecap="round" strokeLinejoin="round"/>
                {/* wheel left */}
                <circle className="cart-wheel cart-wheel--l" cx="52" cy="80" r="7" stroke={this.props.cartColors.wheel} strokeWidth="4" fill={this.props.cartColors.wheelBg}/>
                <circle cx="52" cy="80" r="2" fill={this.props.cartColors.wheel}/>
                {/* wheel right */}
                <circle className="cart-wheel cart-wheel--r" cx="84" cy="80" r="7" stroke={this.props.cartColors.wheel} strokeWidth="4" fill={this.props.cartColors.wheelBg}/>
                <circle cx="84" cy="80" r="2" fill={this.props.cartColors.wheel}/>
                {/* empty lines in basket */}
                <line className="cart-line" x1="60" y1="42" x2="88" y2="42" stroke={`${this.props.cartColors.line}0.3)`} strokeWidth="3" strokeLinecap="round"/>
                <line className="cart-line" x1="57" y1="52" x2="90" y2="52" strokeWidth="3" strokeLinecap="round" stroke={`${this.props.cartColors.line}0.2)`}/>
                <line className="cart-line" x1="54" y1="62" x2="92" y2="62" strokeWidth="3" strokeLinecap="round" stroke={`${this.props.cartColors.line}0.15)`}/>
              </svg>
            </div>
          </div>
          <h2 className="cart-empty-title">Your cart is empty</h2>
          <p className="cart-empty-sub">Add some fresh produce to get started</p>
          <Link to="/"><button className="cart-back-btn"><span>←</span><span>BROWSE STORE</span></button></Link>
        </div>
      );
    }

    const totalKg    = allDisplayItems.reduce(function(s, i) { return s + (i.weight || 0) * i.quantity; }, 0);
    const totalLb    = Math.round(totalKg * 2.20462);
    const totalBoxes = allDisplayItems.reduce(function(s, i) { return s + i.quantity; }, 0);

    // Delivery date logic (Toronto time)
    const now = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Toronto' }));
    const hour = now.getHours();
    const day  = now.getDay(); // 0=Sun,1=Mon...5=Fri,6=Sat
    const delivery = new Date(now);
    if (hour < 4) {
      // До 4am — доставка сьогодні
      // delivery = today, no change
    } else if (day === 5) {
      // П'ятниця після 4am → неділя
      delivery.setDate(delivery.getDate() + 2);
    } else {
      // Всі інші → завтра
      delivery.setDate(delivery.getDate() + 1);
    }
    const dayNames = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
    const monthNames = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    const isSameDay = delivery.toDateString() === now.toDateString();
    const deliveryLabel = isSameDay
      ? 'Today'
      : delivery.toDateString() === new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1).toDateString()
        ? 'Tomorrow'
        : dayNames[delivery.getDay()];
    const deliveryDateLine = deliveryLabel + ', ' + monthNames[delivery.getMonth()] + ' ' + delivery.getDate();
    const deliveryDayLine  = !isSameDay && deliveryLabel !== 'Tomorrow' ? null : dayNames[delivery.getDay()];

    return (
      <div className="cart-page">

        <div className="cart-header-bar">
          <div className="cart-totals">

            <span className="cart-total-item">
              <span className="cart-total-label">
                <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><rect x="1" y="3" width="15" height="13" rx="2"/><path d="M16 8h4l3 5v3h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>
                {' '}Earliest delivery
              </span>
              <span className="cart-total-value cart-delivery-date">
                {deliveryDateLine}
                {deliveryDayLine && <span className="cart-delivery-day">{deliveryDayLine}</span>}
              </span>
            </span>

            <div className="cart-divider" />

            <span className="cart-total-item">
              <span className="cart-total-label">
                <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5"/><path d="M2 12l10 5 10-5"/></svg>
                {' '}Weight
              </span>
              <span className="cart-total-value">
                {totalKg.toFixed(1)}<span className="cart-total-unit">kg</span>
                <span className="cart-total-lb"> / {totalLb}<span className="cart-total-unit">lb</span></span>
              </span>
            </span>

          </div>

          <div className="cart-actions">
            <button
              ref={this.trashRef}
              className="cart-clear-btn"
              onClick={() => { if (window.confirm('Clear cart?')) { this.props.clearCart(); try { localStorage.removeItem('bv_cart_organic'); } catch(e) {} this.setState({organicToggles:{},organicQtys:{},nonOrgQtys:{}}); } }}
              title="Clear cart"
            >
              <svg viewBox="0 0 24 24" fill="none">
                <polyline points="3 6 5 6 21 6" stroke="#dc3545" strokeWidth="2.2" strokeLinecap="round"/>
                <path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6" stroke="#dc3545" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M10 11v6M14 11v6" stroke="#dc3545" strokeWidth="2.2" strokeLinecap="round"/>
                <path d="M9 6V4a1 1 0 011-1h4a1 1 0 011 1v2" stroke="#dc3545" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>

            {!confirmStep ? (
              <button className="cart-send-btn" onClick={this.handleSendOrderClick} disabled={sending}>
                SEND ORDER
                <svg viewBox="0 0 24 24" fill="none">
                  <path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
            ) : (
              <div className="cart-confirm">
                <span>Sure?</span>
                <button className="cart-confirm-yes" onClick={this.handleConfirmOrder} disabled={sending}>
                  {sending ? (
                    <svg className="cart-spinner" viewBox="0 0 24 24" fill="none">
                      <circle cx="12" cy="12" r="10" stroke="rgba(255,255,255,0.3)" strokeWidth="3"/>
                      <path d="M12 2a10 10 0 0 1 10 10" stroke="white" strokeWidth="3" strokeLinecap="round"/>
                    </svg>
                  ) : 'YES'}
                </button>
                <button className="cart-confirm-no" onClick={this.handleCancelOrder} disabled={sending}>NO</button>
              </div>
            )}
          </div>
        </div>

        <div className="cart-table-wrap">
          <table className="cart-table">
            <thead>
              <tr>
                <th></th>
                <th className="th-qty">
                  <div className="th-qty-inner">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg>
                    <span>{totalBoxes}</span>
                  </div>
                </th>
                <th>NAME</th>
                <th>SIZE</th>
                <th>KG | LB</th>
                <th style={{color:'#4caf50', fontSize:'9px', fontWeight:'800', letterSpacing:'0.5px'}}>
                  🌿<br/>ORGANIC
                </th>
              </tr>
            </thead>
            <tbody>
              {allDisplayItems.map((item) => {
                const itemKg = ((item.weight || 0) * item.quantity).toFixed(1);
                const itemLb = Math.round(parseFloat(itemKg) * 2.20462);
                const canOrganic = item.organic;
                const _baseId    = String(item.id).endsWith('_org') ? item.id.replace('_org','') : item.id;
                const isOrganic  = item._displayOrganic !== undefined ? item._displayOrganic : (organicToggles[_baseId] || !!(cartList[_baseId]?.organicSelected));
                const sizeName   = item.quantity_type
                  ? (typeof item.quantity_type === 'object' ? item.quantity_type.name : item.quantity_type)
                  : '';

                return (
                  <tr
                    key={item._splitKey || item.id}
                    className={isOrganic ? 'row-organic' : ''}

                  >
                    <td className="cart-cell-delete">
                      {item._orgOnly ? (
                        <button className="cart-delete-btn" title="Remove organic"
                          onClick={(e) => { e.stopPropagation(); this.handleDelete(item, e); }}>
                          <svg viewBox="0 0 24 24" fill="none"><path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>
                        </button>
                      ) : (
                        <button className="cart-delete-btn" onClick={(e) => { e.stopPropagation(); this.handleDelete(item, e); }} title="Remove">
                          <svg viewBox="0 0 24 24" fill="none"><path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>
                        </button>
                      )}
                    </td>
                    <td className="cart-cell-qty">
                      {item._orgOnly ? (
                        <div className="cart-qty-control">
                          <button onClick={(e) => { e.stopPropagation();
                            const baseId = String(item.id).endsWith('_org') ? item.id.replace('_org','') : item.id;
                            const orgEntry = this.props.cartList[item.id];
                            const cur = orgEntry ? orgEntry.quantity : 1;
                            if (cur <= 1) {
                              this.props.deleteItem(item);
                              this.setState(prev => {
                                const organicToggles = { ...prev.organicToggles, [baseId]: false };
                                const organicQtys    = { ...prev.organicQtys, [baseId]: 0 };
                                const nonOrgQtys     = { ...prev.nonOrgQtys };
                                try { localStorage.setItem('bv_cart_organic', JSON.stringify({ organicToggles, organicQtys, nonOrgQtys })); } catch(e2) {}
                                return { organicToggles, organicQtys, nonOrgQtys };
                              });
                            } else {
                              this.props.decItem({ ...item });
                            }
                          }}>-</button>
                          <span className="cart-qty-organic">{item.quantity}</span>
                          <button onClick={(e) => { e.stopPropagation();
                            if (item.quantity < (window._bvS?.maxCartQty || 99)) this.props.incItem({ ...item });
                          }}>+</button>
                        </div>
                      ) : (
                        <div className="cart-qty-control">
                          {(() => {
                            // Always use real Redux item for dispatch
                            const reduxItem = cartList[item.id]
                              ? {...item, quantity: cartList[item.id].quantity}
                              : item;
                            return (<>
                              <button onClick={(e) => { e.stopPropagation(); this.props.decItem(reduxItem); }}>-</button>
                              <CartQtyInput item={reduxItem} incItem={this.props.incItem} decItem={this.props.decItem}/>
                              <button onClick={(e) => { e.stopPropagation(); if(reduxItem.quantity < (window._bvS?.maxCartQty || 99)) this.props.incItem(reduxItem); }}>+</button>
                            </>);
                          })()}
                        </div>
                      )}
                    </td>
                    <td className="cart-name"
                      onMouseEnter={(e) => { const rect=e.currentTarget.closest('tr').getBoundingClientRect(); if(this.previewTimeout)clearTimeout(this.previewTimeout); if(this._previewFadeTimer)clearTimeout(this._previewFadeTimer); this.setState({previewItem:item,previewY:rect.top,previewFading:false}); this.previewTimeout=setTimeout(()=>{ if(this._unmounted)return; this.setState({previewFading:true}); this._previewFadeTimer=setTimeout(()=>{ if(!this._unmounted)this.setState({previewItem:null,previewFading:false}); },300); },5000); }}
                      onMouseLeave={() => { if(this.previewTimeout)clearTimeout(this.previewTimeout); this.setState({previewItem:null,previewFading:false}); }}
                      onTouchStart={(e)=>this.tapPreview(item,e)}
                    >{item.name}</td>
                    <td className="cart-size">{sizeName}</td>
                    <td className="cart-kg">
                      <span className="kg-val">{itemKg}</span>
                      <span className="kg-unit">kg</span>
                      <span className="kg-sep"> | </span>
                      <span className="lb-val">{itemLb}</span>
                      <span className="kg-unit">lb</span>
                    </td>
                    <td className="cart-organic-cell" onClick={(e) => e.stopPropagation()}>
                      {(() => {
                        const baseId  = String(item.id).endsWith('_org') ? item.id.replace('_org','') : item.id;
                        const orgId   = baseId + '_org';
                        const hasBase = !!cartList[baseId];
                        const hasOrg  = !!(cartList[orgId]?.quantity > 0);
                        const isOn    = !!(organicToggles[baseId]) || !!(cartList[baseId]?.organicSelected);

                        if (item._orgOnly) {
                          // Органік рядок — якщо є базовий то без тумблера, якщо тільки органік — тумблер
                          if (hasBase) return <span style={{fontSize:16}}>🌿</span>;
                          // Тільки органік — тумблер для вибору non-organic qty
                          return (
                            <label className="organic-toggle" onPointerDown={(e) => e.stopPropagation()}>
                              <input type="checkbox" checked={true}
                                onChange={() => this.toggleOrganic(baseId, item.quantity)}/>
                              <span className="organic-slider"/>
                            </label>
                          );
                        }

                        if (!canOrganic) return <span className="organic-na">-</span>;

                        // Базовий item
                        if (hasOrg) {
                          // Є і базовий і органік — тумблер не показуємо
                          return <span className="organic-na">-</span>;
                        }

                        // Тільки базовий — показуємо тумблер
                        return (
                          <label className="organic-toggle" onPointerDown={(e) => e.stopPropagation()}>
                            <input type="checkbox" checked={isOn}
                              onChange={() => {
                                const realQty = this.props.cartList[baseId]?.quantity || item.quantity;
                                this.toggleOrganic(baseId, realQty);
                              }}/>
                            <span className="organic-slider"/>
                          </label>
                        );
                      })()}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        {previewItem && previewItem.image && previewItem.image[0] && (
          <div
            className={'cart-img-preview' + (previewFading ? ' cart-img-preview--fading' : '')}
            style={{ top: Math.max(10, previewY - 80) + 'px' }}
            onPointerDown={() => {
              if (this.previewTimeout) clearTimeout(this.previewTimeout);
              if (this.scrollListener) window.removeEventListener('scroll', this.scrollListener, true);
              this.setState({ previewItem: null, previewFading: false });
            }}
          >
            <div style={{position:'absolute',top:6,right:6,width:22,height:22,borderRadius:'50%',
              background:'rgba(0,0,0,0.55)',color:'#fff',fontSize:13,
              display:'flex',alignItems:'center',justifyContent:'center',
              zIndex:10,pointerEvents:'none'}}>✕</div>
            <img src={previewItem.image[0].url} alt={previewItem.name} loading="lazy" />
            <div className="cart-img-preview-name">{previewItem.name}</div>
          </div>
        )}

      {/* Organic qty modal */}
      {organicModal && (() => {
        const { id } = organicModal;
        const item = cartItems.find(i => i.id === id);
        // Always use real qty from Redux store, not split display qty
        const qty = this.props.cartList[id]?.quantity || organicModal.qty;
        const curOrgQty = organicQtys[id] || 1;
        const half = Math.floor(qty / 2);

        // Options: All, Half (if >2), 1, 2, Cancel — nothing else
        const options = [];
        options.push({ label: `All (${qty})`, val: qty });
        if (half > 2) options.push({ label: `Half (${half})`, val: half });
        options.push({ label: '1', val: 1 });
        if (qty > 2) options.push({ label: '2', val: 2 });

        const btnStyle = (val) => ({
          flex:'1 1 calc(50% - 4px)', minWidth:80, padding:'12px 8px', borderRadius:12,
          border:'1.5px solid #e8d5b0', cursor:'pointer', fontWeight:800, fontSize:13,
          background: curOrgQty===val ? '#2a1200' : '#fffbf3',
          color:      curOrgQty===val ? '#fff'    : '#2a1200',
        });

        return (
          <div style={{position:'fixed',inset:0,zIndex:300,background:'rgba(0,0,0,0.45)',display:'flex',alignItems:'flex-end',justifyContent:'center'}}
            onClick={() => this.setState({ organicModal: null })}>
            <div style={{background:'#fff',borderRadius:'20px 20px 0 0',padding:'24px 20px 36px',width:'100%',maxWidth:480}}
              onClick={e => e.stopPropagation()}>
              <div style={{fontSize:15,fontWeight:800,color:'#2a1200',marginBottom:4}}>🌿 Organic — {item?.name}</div>
              <div style={{fontSize:12,color:'#8b6a3a',marginBottom:16}}>How many boxes organic?</div>
              <div style={{display:'flex',gap:8,flexWrap:'wrap',marginBottom:16}}>
                {options.map(opt => (
                  <button key={opt.val} onClick={() => this.setOrganicQty(id, qty, opt.val)}
                    style={btnStyle(opt.val)}>
                    {opt.label}
                  </button>
                ))}
              </div>
              <div style={{display:'flex',gap:8}}>
                <button onClick={() => this.setState({ organicModal: null })}
                  style={{flex:1,padding:'12px',borderRadius:12,border:'1.5px solid #e8d5b0',background:'#fffbf3',color:'#8b4e0a',fontWeight:700,fontSize:13,cursor:'pointer'}}>
                  Cancel
                </button>
                <button onClick={() => this.setOrganicQty(id, qty, 0)}
                  style={{flex:1,padding:'12px',borderRadius:12,border:'none',background:'#f5f5f5',color:'#999',fontWeight:700,fontSize:13,cursor:'pointer'}}>
                  None
                </button>
              </div>
            </div>
          </div>
        );
      })()}

    </div>
    );
  }
}

const mapStateToProps = function(state) {
  return { cartList: state.cart, allProducts: state.products };
};

const mapDispatchToProps = function(dispatch) {
  return {
    showSearch: function(value) { dispatch(showSearch(value)); },
    clearCart:  function() { dispatch({ type: "CLEAR_CART" }); },
    incItem:    function(product) { dispatch(addToCart(product)); },
    decItem:    function(product) { dispatch(removeFromCart(product)); },
    deleteItem:     function(product) { dispatch({ type: "DELETE_FROM_CART", product: product }); },
    updateCartItem: function(id, patch) { dispatch(updateCartItem(id, patch)); },
  };
};

const ConnectedCart = connect(mapStateToProps, mapDispatchToProps)(Cart);

function withNavigate(Component) {
  return function WithNavigateWrapper(props) {
    const navigate = useNavigate();
    return <Component {...props} navigate={navigate} />;
  };
}

// Define OUTSIDE CartWithTheme to prevent remount on every re-render
const ConnectedCartWithNav = withNavigate(ConnectedCart);

const CartWithTheme = (props) => {
  const { theme } = useTheme();
  const cartColors = getTheme(theme).cart;
  return <ConnectedCartWithNav {...props} cartColors={cartColors} />;
};

export default CartWithTheme;
